import { render, staticRenderFns } from "./LiteracyRankingDetail.vue?vue&type=template&id=63a07074&scoped=true"
import script from "./LiteracyRankingDetail.vue?vue&type=script&lang=js"
export * from "./LiteracyRankingDetail.vue?vue&type=script&lang=js"
import style0 from "./LiteracyRankingDetail.vue?vue&type=style&index=0&id=63a07074&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a07074",
  null
  
)

export default component.exports